export const INVESTMENT_TYPES = [
  { value: 'fund', label: 'Fund', description: 'Invest through managed funds' },
  {
    value: 'syndicate',
    label: 'Syndicate',
    description: 'Co-invest alongside lead investors via Special Purpose Vehicles (SPVs)',
  },
  { value: 'angel_group', label: 'Angel Group', description: 'Invest directly in companies' },
]

export const INVESTMENT_SIZES = [
  '$10,000 - $50,000',
  '$50,000 - $100,000',
  '$100,000 - $250,000',
  '$250,000 - $500,000',
  '$500,000 - $1,000,000',
  '$1,000,000+',
]

export const INVESTMENT_SIZE_LABELS: Record<string, string> = {
  '$10,000 - $50,000': '$10K–$50K',
  '$50,000 - $100,000': '$50K–$100K',
  '$100,000 - $250,000': '$100K–$250K',
  '$250,000 - $500,000': '$250K–$500K',
  '$500,000 - $1,000,000': '$500K–$1M',
  '$1,000,000+': '$1M+',
}

export const INVESTMENT_TYPE_LABELS: Record<string, string> = {
  fund: 'Fund',
  syndicate: 'Syndicate',
  angel_group: 'Angel Group',
}
